module.exports = __webpack_public_path__ + "static/media/Passport-Front1.da2a1e5c.png";